import { bostaHttp } from 'http.js';

export const getAllNotifications = (payload) => {
  return bostaHttp.get(`/notifications`, payload);
};

export const getCountNotification = () => {
  return bostaHttp.get(`/notifications/count`);
};
